//import http from "./http";
import axios from "axios"; 

//const app_url = 'http://127.0.0.1:8000';

const app_url = 'dev-api.dgbook.africa';

export { app_url }

const http = axios.create({
    baseURL: 'dev-api.dgbook.africa', 
    headers: {
        "Content-Type": "application/json"
    }
})

class AuthService {
     // getuser
 /*getUser = (token) => {
    return api.get(`getuser`,{ headers: { 'Authorization': 'Bearer '+token } });
}*/

    login(data) {
        return http.post("/api/login", data)
    } 

    logout(data) {
        return http.post("/api/logout", data,{ headers: { 'Authorization': 'Bearer '+data } })
    }

    register(data) {
        return http.post("/api/store/inscrit", data)
    }

    registerEntreprise(data) {
        return http.post("/api/store/inscrit/entreprise", data)
    }

    activeStorage() {
        return http.get("/api/ActiveStorage")
    }

    clearCache() {
        return http.get("/api/ClearCache")
    }

    forgetPassword(data){
        return http.post("/api/forget-password", data)
    }

    changePassword(data){
        return http.post("/api/reset-password", data)
    }

} 

export default new AuthService